const normalizeValue = (value) => String(value ?? '').trim();

const optionalField = (value) => {
  const normalized = normalizeValue(value);
  return normalized && normalized !== '__none__' ? normalized : '';
};

export const dashboardGlobalContext = () => ({
  scope: 'global',
});

export const requirementsFilterContext = (filters = {}) => {
  const customerId = optionalField(filters.customer ?? filters.customerId);
  const projectId = optionalField(filters.project ?? filters.projectId);
  const from = optionalField(filters.from);
  const to = optionalField(filters.to);
  return {
    scope: 'global',
    ...(customerId ? { customerId } : {}),
    ...(projectId ? { projectId } : {}),
    ...(from ? { from } : {}),
    ...(to ? { to } : {}),
  };
};

export const conversationQaContext = ({ conversationId, customerId, projectId } = {}) => {
  const normalizedConversationId = optionalField(conversationId);
  const normalizedCustomer = optionalField(customerId);
  const normalizedProject = optionalField(projectId);

  return {
    scope: 'conversation',
    ...(normalizedConversationId ? { conversationId: normalizedConversationId } : {}),
    ...(normalizedCustomer ? { customerId: normalizedCustomer } : {}),
    ...(normalizedProject ? { projectId: normalizedProject } : {}),
  };
};

export const customerProjectContext = ({ customerId, projectId } = {}) => {
  const normalizedCustomer = optionalField(customerId);
  const normalizedProject = optionalField(projectId);
  return {
    scope: 'global',
    ...(normalizedCustomer ? { customerId: normalizedCustomer } : {}),
    ...(normalizedProject ? { projectId: normalizedProject } : {}),
  };
};
